var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52 6.5V9.04667H3V11.54C3 15.7133 4.24 18.04 7.22 19.4867C8.32786 20.0823 9.3504 20.8246 10.26 21.6933C10.9914 22.4728 11.8829 23.0846 12.8733 23.4867L14 23.8333V26.8533H12.28C10.2 26.8533 9.5 27.3267 9.5 28.7333V29.68H22.5V28.8333C22.5 27.4533 21.6467 26.8333 19.6733 26.8333H18V23.8333L19.1467 23.4933C20.1387 23.0913 21.0307 22.4769 21.76 21.6933C22.7092 20.7892 23.7713 20.0116 24.92 19.38C25.8121 18.9507 26.6087 18.3465 27.2627 17.6032C27.9166 16.8599 28.4145 15.9928 28.7267 15.0533C28.9388 13.8901 29.037 12.709 29.02 11.5267V9.05333H24.48V6.5H7.52ZM16 10.7467L17.3667 13.5733H20.66L18.08 15.9533L18.82 18.9933L16 17.48L13.18 19.0133L13.92 15.9733L11.3333 13.5933H14.6333L16 10.7467ZM5.37333 11.5933H7.48V16.8467C7.26 16.98 6.57333 16.18 6.07333 15.2667C5.78938 14.5675 5.60752 13.831 5.53333 13.08L5.37333 11.5933ZM24.52 11.5933H26.8133L26.62 13.06C26.5746 14.2809 26.0837 15.443 25.24 16.3267C25.0412 16.5969 24.7894 16.8237 24.5 16.9933L24.52 11.5933Z",
    stroke: "#192BC2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/Rewards.d54aa84a4cf3eff8673dc9337fc8bf4c.svg";
export { ForwardRef as ReactComponent };